import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { GetSessionError } from '~/backend/connector-api/connector-components';
import {
    TranslationCustomizationFile,
    UserCustomization,
} from '~/backend/types';
import ImageDataDisplay from '~/components/InputDataPreview/ImageDataDisplay';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import ModelSelection from './ImageTranslationModelSelection';

type ImageTranslationProps = {
    availableModels: PredictionModel[];
    modelCustomizations: UserCustomization<TranslationCustomizationFile>[];
    onSubmit: (model: PredictionModel, selectedCustomization?: string) => void;
    isLoadingModels: boolean;
    isSubmitting?: boolean;
    showPseudonymization: boolean;
    isLoadingSession?: boolean;
    error?: Error | GetSessionError | null;
};

export default function ImageTranslation({
    availableModels,
    modelCustomizations,
    onSubmit,
    isLoadingModels,
    isSubmitting,
    isLoadingSession,
    error,
    showPseudonymization,
}: ImageTranslationProps) {
    const primaryImage = useRecoilValue(primaryImageState);
    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <FormattedMessage id="runImageTranslation" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="runImageTranslationDescription" />
                </Typography>
            </Box>
            <ImageDataDisplay
                image={primaryImage}
                isLoading={isLoadingSession}
                error={error}
            />
            <ModelSelection
                isLoadingModels={isLoadingModels}
                availableModels={availableModels}
                modelCustomizations={modelCustomizations}
                onSubmit={onSubmit}
                modality={primaryImage?.seriesMetadata.modality}
                showPseudonymization={showPseudonymization}
                disabled={isLoadingSession || isLoadingModels}
                isSubmitting={isSubmitting}
            />
        </Box>
    );
}
